import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cs-header-content',
  templateUrl: 'cs-header-content.html',
  host: { 'class': 'header-content' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsHeaderContent {}
